import * as types from 'constants/actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {

    case types.RECEIVE_REFERENCES:
      return action.references

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/references.js